export default __webpack_public_path__ + "static/media/slider-img23.289aa0c2.jpg";